import React, { useState, useEffect } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Iter 264 (Kamel) — Générateur d'affiches réseaux : places disponibles OU lancement
// de nouveau voyage, format carré (posts) ou vertical 9:16 (TikTok / Stories).
const AfficheModal = ({ open, onClose, initial = {} }) => {
  const [form, setForm] = useState({
    type: 'places', format: 'carre', badge: '',
    places: '2', destination: '', dates: '', transport: 'Transport en autocar inclus',
    prix: '', telephone: '06 60 41 62 18', image_url: '',
  });
  const [imgUrl, setImgUrl] = useState(null);
  const [imgBlob, setImgBlob] = useState(null);
  const [waText, setWaText] = useState('');
  const [copied, setCopied] = useState(false);
  const [shareInfo, setShareInfo] = useState('');
  const [loading, setLoading] = useState(null); // 'template' | 'ia' | null
  const [error, setError] = useState('');
  // Iter 266 — Photothèque destinations (1 clic)
  const [photos, setPhotos] = useState(null);
  // Iter 840 — 3 propositions IA, photo gardée, textes réseaux
  const [props3, setProps3] = useState([]);
  const [photoId, setPhotoId] = useState(null);
  const [gardee, setGardee] = useState(false);
  const [textes, setTextes] = useState(null);
  const [copiedKey, setCopiedKey] = useState('');
  const [addPhoto, setAddPhoto] = useState(null); // { label, url } | null

  useEffect(() => {
    if (open && photos === null) {
      const auth = localStorage.getItem('admin_auth');
      fetch(`${API}/admin/affiche/photos`, { headers: { Authorization: `Basic ${auth}` } })
        .then(r => r.json()).then(d => setPhotos(d.items || [])).catch(() => setPhotos([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (open) {
      setForm(f => ({ ...f, ...initial }));
      setImgUrl(null);
      setImgBlob(null);
      setWaText('');
      setError('');
      setShareInfo('');
      setProps3([]); setPhotoId(null); setGardee(false); setTextes(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  if (!open) return null;

  const isLancement = form.type === 'lancement';

  const buildWaText = () => {
    const ligne3 = [form.transport, form.prix].filter(Boolean).join(' — ');
    if (isLancement) {
      return (
        `🚀 *NOUVEAU VOYAGE RAAV !*\n` +
        `📍 ${form.destination}\n` +
        (form.dates ? `🗓️ ${form.dates}\n` : '') +
        (ligne3 ? `🚌 ${ligne3}\n` : '') +
        `\nInscriptions ouvertes dès maintenant !\n` +
        `👉 www.rhoneamitievoyages.fr/inscription\n` +
        `📱 WhatsApp : ${form.telephone}\n` +
        `\n#voyage #vacances #bonplan #lyon`
      );
    }
    const p = form.places || '2';
    return (
      `🌴 *${p} PLACE${p !== '1' ? 'S' : ''} DISPONIBLE${p !== '1' ? 'S' : ''} !*\n` +
      `📍 ${form.destination}\n` +
      (form.dates ? `🗓️ ${form.dates}\n` : '') +
      (ligne3 ? `🚌 ${ligne3}\n` : '') +
      `\nRéservez vite : premier arrivé, premier servi !\n` +
      `📱 WhatsApp : ${form.telephone}\n` +
      `👉 Inscription en ligne : www.rhoneamitievoyages.fr/inscription`
    );
  };

  const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: `Basic ${localStorage.getItem('admin_auth')}` });

  const propositions = async () => {
    if (!form.destination.trim()) { setError('Indique au moins la destination.'); return; }
    setLoading('props'); setError(''); setProps3([]); setPhotoId(null); setGardee(false);
    try {
      const r = await fetch(`${API}/admin/affiche/propositions`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
      const j = await r.json();
      if (!r.ok) throw new Error(j?.detail || 'Erreur IA');
      setProps3(j.propositions || []);
      if (j.echecs) setShareInfo(`${j.echecs} proposition(s) n'ont pas abouti — relance si besoin.`);
    } catch (e) { setError(e.message); }
    setLoading(null);
  };

  const choisir = async (pid) => { setPhotoId(pid); setGardee(false); await generer('ia', { photo_id: pid }); };

  const garderPhoto = async () => {
    if (!photoId) return;
    try {
      const r = await fetch(`${API}/admin/affiche/photos/ia/${photoId}`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ label: `${form.destination} (IA)` }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j?.detail || 'Erreur');
      setGardee(true);
      if (j.photo) setPhotos(p => [j.photo, ...(p || [])]);
    } catch (e) { setError(e.message); }
  };

  const genererTextes = async () => {
    setLoading('textes'); setError('');
    try {
      const r = await fetch(`${API}/admin/affiche/textes`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
      const j = await r.json();
      if (!r.ok) throw new Error(j?.detail || 'Erreur IA');
      setTextes(j.textes || {});
    } catch (e) { setError(e.message); }
    setLoading(null);
  };

  const copier = async (key, txt) => {
    try { await navigator.clipboard.writeText(txt); setCopiedKey(key); setTimeout(() => setCopiedKey(''), 2000); } catch { /* indisponible */ }
  };

  const generer = async (mode, extra = {}) => {
    if (!form.destination.trim()) { setError('Indique au moins la destination.'); return; }
    setLoading(mode);
    setError('');
    try {
      const auth = localStorage.getItem('admin_auth');
      const r = await fetch(`${API}/admin/affiche/generer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Basic ${auth}` },
        body: JSON.stringify({ ...form, mode, ...extra }),
      });
      if (!r.ok) {
        let msg = 'Erreur de génération.';
        try { const j = await r.json(); if (j?.detail) msg = j.detail; } catch { /* ignore */ }
        throw new Error(msg);
      }
      const blob = await r.blob();
      if (imgUrl) URL.revokeObjectURL(imgUrl);
      setImgUrl(URL.createObjectURL(blob));
      setImgBlob(blob);
      setWaText(buildWaText());
      setShareInfo('');
      setCopied(false);
    } catch (e) { setError(e.message); }
    setLoading(null);
  };

  // Iter 841 — carré + story 9:16 avec la même photo, d'un clic (photo IA choisie ou photo du catalogue)
  const telechargerDuo = async () => {
    setLoading('duo'); setError('');
    try {
      const base = form.destination.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
      for (const fmt of ['carre', 'vertical']) {
        const r = await fetch(`${API}/admin/affiche/generer`, { method: 'POST', headers: authHeaders(),
          body: JSON.stringify({ ...form, format: fmt, mode: photoId ? 'ia' : 'template', ...(photoId ? { photo_id: photoId } : {}) }) });
        if (!r.ok) { let msg = 'Erreur de génération.'; try { const j = await r.json(); if (j?.detail) msg = j.detail; } catch { /* ignore */ } throw new Error(msg); }
        const url = URL.createObjectURL(await r.blob());
        const a = document.createElement('a'); a.href = url; a.download = `affiche-${base}-${fmt === 'carre' ? 'carre' : 'story'}.png`; a.click();
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      }
      setShareInfo('✅ Deux fichiers téléchargés : carré (Facebook / Instagram) et story 9:16 (TikTok / Snapchat / stories).');
    } catch (e) { setError(e.message); }
    setLoading(null);
  };

  const telecharger = () => {
    const a = document.createElement('a');
    a.href = imgUrl;
    a.download = `affiche-${form.destination.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}${form.format === 'vertical' ? '-tiktok' : ''}.png`;
    a.click();
  };

  const copierTexte = async () => {
    try {
      await navigator.clipboard.writeText(waText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch { /* clipboard indisponible */ }
  };

  // Partage natif (mobile : WhatsApp/TikTok reçoivent l'affiche + le texte directement).
  // Fallback desktop : copie le texte, télécharge l'affiche et ouvre WhatsApp Web.
  const partagerWhatsApp = async () => {
    const file = new File([imgBlob], 'affiche-raav.png', { type: 'image/png' });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file], text: waText });
        return;
      } catch (e) {
        if (e.name === 'AbortError') return; // l'utilisateur a annulé
      }
    }
    await copierTexte();
    telecharger();
    window.open(`https://wa.me/?text=${encodeURIComponent(waText)}`, '_blank');
    setShareInfo("💡 Sur ordinateur : le texte est collé dans WhatsApp — joins l'affiche téléchargée (trombone 📎) avant d'envoyer.");
  };

  const input = 'border rounded px-2 py-1.5 text-xs w-full';
  const pill = (active) => `flex-1 px-3 py-2 rounded-lg text-xs font-bold border-2 transition ${active ? 'bg-[#1E3A5F] text-white border-[#1E3A5F]' : 'bg-white text-gray-600 border-gray-200 hover:border-[#1E3A5F]'}`;

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={onClose} data-testid="affiche-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[92vh] overflow-y-auto p-5"
        onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-bold text-[#1E3A5F]">🎨 Affiche pour les réseaux sociaux</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg" data-testid="affiche-close">✕</button>
        </div>

        {/* Type d'affiche */}
        <div className="flex gap-2 mb-2">
          <button onClick={() => setForm({ ...form, type: 'places' })} className={pill(!isLancement)} data-testid="affiche-type-places">
            🔥 Places disponibles
          </button>
          <button onClick={() => setForm({ ...form, type: 'lancement' })} className={pill(isLancement)} data-testid="affiche-type-lancement">
            🚀 Lancement nouveau voyage
          </button>
        </div>
        {/* Format */}
        <div className="flex gap-2 mb-3">
          <button onClick={() => setForm({ ...form, format: 'carre' })} className={pill(form.format === 'carre')} data-testid="affiche-format-carre">
            ⬛ Carré — posts Facebook / Insta
          </button>
          <button onClick={() => setForm({ ...form, format: 'vertical' })} className={pill(form.format === 'vertical')} data-testid="affiche-format-vertical">
            📱 Vertical 9:16 — TikTok / Stories
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 mb-3">
          {isLancement ? (
            <div className="col-span-2 md:col-span-3">
              <label className="text-[10px] font-bold text-gray-500 uppercase">Texte du badge</label>
              <input value={form.badge} onChange={e => setForm({ ...form, badge: e.target.value })}
                placeholder="NOUVEAU VOYAGE !" className={input} data-testid="affiche-badge" />
            </div>
          ) : (
            <div>
              <label className="text-[10px] font-bold text-gray-500 uppercase">Nb places</label>
              <input type="number" min="1" value={form.places} onChange={e => setForm({ ...form, places: e.target.value })}
                className={input} data-testid="affiche-places" />
            </div>
          )}
          <div className="col-span-2">
            <label className="text-[10px] font-bold text-gray-500 uppercase">Destination *</label>
            <input value={form.destination} onChange={e => setForm({ ...form, destination: e.target.value })}
              placeholder="Lloret de Mar — Espagne" className={input} data-testid="affiche-destination" />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase">Dates</label>
            <input value={form.dates} onChange={e => setForm({ ...form, dates: e.target.value })}
              placeholder="1ᵉʳ → 8 août 2026" className={input} data-testid="affiche-dates" />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase">Transport</label>
            <select value={form.transport} onChange={e => setForm({ ...form, transport: e.target.value })}
              className={input} data-testid="affiche-transport">
              <option value="Transport en autocar inclus">Transport en autocar inclus</option>
              <option value="Sans transport (sur place)">Sans transport (sur place)</option>
              <option value="Vol inclus">Vol inclus</option>
              <option value="">— Ne pas afficher —</option>
            </select>
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase">Prix (optionnel)</label>
            <input value={form.prix} onChange={e => setForm({ ...form, prix: e.target.value })}
              placeholder="520 €" className={input} data-testid="affiche-prix" />
          </div>
          <div>
            <label className="text-[10px] font-bold text-gray-500 uppercase">Téléphone</label>
            <input value={form.telephone} onChange={e => setForm({ ...form, telephone: e.target.value })}
              className={input} data-testid="affiche-telephone" />
          </div>
          <div className="col-span-2">
            <label className="text-[10px] font-bold text-gray-500 uppercase">Photo de fond (URL — optionnel, sinon plage par défaut)</label>
            <input value={form.image_url || ''} onChange={e => setForm({ ...form, image_url: e.target.value })}
              placeholder="https://… (colle l'adresse d'une photo de la destination)" className={input} data-testid="affiche-image-url" />
          </div>
          {/* Iter 266 — Photothèque : choisir une photo en 1 clic */}
          <div className="col-span-2 md:col-span-3">
            <div className="flex items-center justify-between mb-1">
              <label className="text-[10px] font-bold text-gray-500 uppercase">📚 Photothèque — clique pour choisir</label>
              <button onClick={() => setAddPhoto(addPhoto ? null : { label: '', url: '' })}
                className="text-[10px] font-bold px-2 py-0.5 bg-gray-700 text-white rounded hover:bg-gray-800"
                data-testid="phototheque-add-toggle">{addPhoto ? '✕' : '➕ Ajouter une photo'}</button>
            </div>
            {addPhoto && (
              <div className="flex gap-1.5 mb-2">
                <input value={addPhoto.label} onChange={e => setAddPhoto({ ...addPhoto, label: e.target.value })}
                  placeholder="Nom (ex : Lloret plage)" className="border rounded px-2 py-1 text-xs w-36" data-testid="phototheque-label" />
                <input value={addPhoto.url} onChange={e => setAddPhoto({ ...addPhoto, url: e.target.value })}
                  placeholder="https://…" className="border rounded px-2 py-1 text-xs flex-1" data-testid="phototheque-url" />
                <button onClick={async () => {
                  const auth = localStorage.getItem('admin_auth');
                  const r = await fetch(`${API}/admin/affiche/photos`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Basic ${auth}` },
                    body: JSON.stringify(addPhoto),
                  });
                  if (r.ok) { const j = await r.json(); setPhotos([j.photo, ...(photos || [])]); setAddPhoto(null); }
                  else { try { const j = await r.json(); setError(j.detail || 'Erreur'); } catch { setError('Erreur'); } }
                }} className="text-xs font-bold px-3 py-1 bg-[#1E3A5F] text-white rounded" data-testid="phototheque-save">OK</button>
              </div>
            )}
            {photos === null ? (
              <p className="text-[10px] text-gray-400 italic">Chargement…</p>
            ) : photos.length === 0 ? (
              <p className="text-[10px] text-gray-400 italic">Aucune photo — ajoute-en une ou colle une URL ci-dessus.</p>
            ) : (
              <div className="flex gap-1.5 overflow-x-auto pb-1" data-testid="phototheque-row">
                {photos.map(p => (
                  <div key={p.id} className="relative flex-shrink-0 group">
                    <button onClick={() => setForm({ ...form, image_url: p.url })}
                      title={p.label}
                      className={`block w-20 h-14 rounded-lg overflow-hidden border-2 transition ${form.image_url === p.url ? 'border-[#1E3A5F] ring-2 ring-[#1E3A5F]/30' : 'border-gray-200 hover:border-[#1E3A5F]'}`}
                      data-testid={`phototheque-pick-${p.id}`}>
                      <img src={p.url} alt={p.label} className="w-full h-full object-cover" loading="lazy" />
                    </button>
                    <p className="text-[8px] text-gray-500 truncate w-20 text-center">{p.label}</p>
                    {!p.builtin && (
                      <button onClick={async () => {
                        const auth = localStorage.getItem('admin_auth');
                        await fetch(`${API}/admin/affiche/photos/${p.id}`, { method: 'DELETE', headers: { Authorization: `Basic ${auth}` } });
                        setPhotos(photos.filter(x => x.id !== p.id));
                      }} className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white rounded-full text-[8px] font-bold opacity-0 group-hover:opacity-100 transition"
                        title="Supprimer" data-testid={`phototheque-del-${p.id}`}>✕</button>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {error && <p className="text-xs text-red-600 font-semibold mb-2" data-testid="affiche-error">⚠ {error}</p>}
        <div className="mb-2">
          <input type="text" value={form.ambiance || ''} onChange={e => setForm(f => ({ ...f, ambiance: e.target.value }))}
            placeholder="Ambiance (optionnel) — vide = l'IA s'inspire librement du voyage, tu valides ou tu relances"
            className="w-full border rounded-lg px-3 py-2 text-xs" data-testid="affiche-ambiance" />
        </div>
        <div className="flex gap-2 mb-3">
          <button onClick={() => generer('template')} disabled={!!loading}
            className="flex-1 bg-[#1E3A5F] text-white px-3 py-2.5 rounded-lg text-xs font-bold hover:bg-[#2d4d77] disabled:opacity-50 transition"
            data-testid="affiche-generer-template">
            {loading === 'template' ? '⏳ Génération…' : '🖼️ Affiche RAAV (instantané)'}
          </button>
          <button onClick={() => generer('ia')} disabled={!!loading}
            className="flex-1 bg-purple-600 text-white px-3 py-2.5 rounded-lg text-xs font-bold hover:bg-purple-700 disabled:opacity-50 transition"
            data-testid="affiche-generer-ia"
            title="L'IA crée une belle photo de la destination (sans texte), puis le gabarit RAAV pose les textes proprement — zéro faute (~20-30 s, un peu de crédit)">
            {loading === 'ia' ? '⏳ L\'IA photographie… (~20 s)' : '✨ Photo IA + textes RAAV'}
          </button>
          <button onClick={propositions} disabled={!!loading}
            className="flex-1 bg-fuchsia-700 text-white px-3 py-2.5 rounded-lg text-xs font-bold hover:bg-fuchsia-800 disabled:opacity-50 transition"
            data-testid="affiche-propositions"
            title="3 photos IA différentes côte à côte : tu cliques sur celle que tu préfères (~30-40 s, 3× le crédit d'une photo)">
            {loading === 'props' ? '⏳ 3 photos en cours… (~40 s)' : '🎲 3 propositions IA'}
          </button>
        </div>
        {props3.length > 0 && (
          <div className="mb-3" data-testid="affiche-propositions-grid">
            <p className="text-[10px] font-bold text-gray-500 uppercase mb-1">Choisis ta préférée (clic) — la finale est recomposée en pleine qualité</p>
            <div className="grid grid-cols-3 gap-2">
              {props3.map((p, i) => (
                <button key={p.photo_id} onClick={() => choisir(p.photo_id)} disabled={!!loading}
                  className={`rounded-lg overflow-hidden border-4 transition ${photoId === p.photo_id ? 'border-fuchsia-600' : 'border-transparent hover:border-fuchsia-300'}`}
                  data-testid={`affiche-proposition-${i}`} title="Choisir cette proposition">
                  <img src={p.apercu} alt={`Proposition ${i + 1}`} className="w-full" />
                </button>
              ))}
            </div>
          </div>
        )}
        {imgUrl && (
          <div className="space-y-2" data-testid="affiche-preview-block">
            <img src={imgUrl} alt="Affiche générée"
              className={`rounded-xl border-2 border-gray-200 shadow ${form.format === 'vertical' ? 'max-h-[420px] mx-auto' : 'w-full'}`}
              data-testid="affiche-preview" />
            <div className="flex gap-2">
              <button onClick={partagerWhatsApp}
                className="flex-1 bg-[#25D366] text-white px-3 py-2.5 rounded-lg text-xs font-bold hover:bg-[#1fb457] transition"
                title="Sur téléphone : ouvre le partage avec l'affiche + le texte (WhatsApp, TikTok…). Sur ordinateur : copie le texte, télécharge l'affiche et ouvre WhatsApp Web."
                data-testid="affiche-partager-whatsapp">
                📱 Partager (affiche + texte)
              </button>
              <button onClick={telecharger}
                className="bg-green-700 text-white px-3 py-2.5 rounded-lg text-xs font-bold hover:bg-green-800 transition"
                data-testid="affiche-telecharger">
                ⬇️ PNG
              </button>
              <button onClick={telechargerDuo} disabled={!!loading}
                className="bg-sky-700 text-white px-3 py-2.5 rounded-lg text-xs font-bold hover:bg-sky-800 disabled:opacity-50 transition"
                title="Télécharge les deux formats avec la même photo : carré 1:1 et story 9:16"
                data-testid="affiche-telecharger-duo">
                {loading === 'duo' ? '⏳' : '⬇️ Carré + Story'}
              </button>
            </div>
            {shareInfo && <p className="text-[11px] text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="affiche-share-info">{shareInfo}</p>}
            {photoId && (
              <button onClick={garderPhoto} disabled={gardee}
                className={`w-full px-3 py-2 rounded-lg text-xs font-bold transition ${gardee ? 'bg-emerald-100 text-emerald-800' : 'bg-white border border-fuchsia-600 text-fuchsia-800 hover:bg-fuchsia-50'}`}
                data-testid="affiche-garder-photo" title="La photo IA (sans texte) entre dans la photothèque : réutilisable sur le site et les prochaines affiches">
                {gardee ? '✅ Photo gardée dans la photothèque' : '📚 Garder cette photo dans la photothèque'}
              </button>
            )}
            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="text-[10px] font-bold text-gray-500 uppercase">📣 Textes assortis — TikTok · Snapchat · Instagram · Facebook · WhatsApp</label>
                <button onClick={genererTextes} disabled={!!loading}
                  className="text-[10px] font-bold px-2 py-1 bg-[#1E3A5F] text-white rounded hover:bg-[#2d4d77] disabled:opacity-50"
                  data-testid="affiche-textes-generer">
                  {loading === 'textes' ? '⏳ Rédaction…' : textes ? '🔁 Autres textes' : '✍️ Rédiger les textes'}
                </button>
              </div>
              {textes && (
                <div className="space-y-2" data-testid="affiche-textes">
                  {Object.entries({ tiktok: '🎵 TikTok', snapchat: '👻 Snapchat', instagram: '📸 Instagram', facebook: '📘 Facebook', whatsapp: '💬 WhatsApp', youtube: '▶️ YouTube (titre + description)' }).filter(([k]) => textes[k]).map(([k, lab]) => (
                    <div key={k} className="border rounded-lg p-2 bg-gray-50">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-[11px] font-bold text-[#1E3A5F]">{lab}</span>
                        <button onClick={() => copier(k, textes[k])} className="text-[10px] font-bold px-2 py-0.5 bg-gray-700 text-white rounded hover:bg-gray-800" data-testid={`affiche-copier-${k}`}>
                          {copiedKey === k ? '✅ Copié !' : '📋 Copier'}
                        </button>
                      </div>
                      <textarea value={textes[k]} onChange={e => setTextes(t => ({ ...t, [k]: e.target.value }))} rows={k === 'snapchat' ? 2 : 5}
                        className="w-full border rounded px-2 py-1 text-xs bg-white" data-testid={`affiche-texte-${k}`} />
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div>
              <div className="flex items-center justify-between mb-1">
                <label className="text-[10px] font-bold text-gray-500 uppercase">💬 Texte prêt pour les groupes / la description (modifiable)</label>
                <button onClick={copierTexte}
                  className="text-[10px] font-bold px-2 py-1 bg-gray-700 text-white rounded hover:bg-gray-800"
                  data-testid="affiche-copier-texte">
                  {copied ? '✅ Copié !' : '📋 Copier le texte'}
                </button>
              </div>
              <textarea value={waText} onChange={e => setWaText(e.target.value)} rows={8}
                className="w-full border rounded-lg px-2 py-1.5 text-xs font-mono" data-testid="affiche-wa-texte" />
            </div>
            <p className="text-[10px] text-gray-500 text-center">Pas satisfait ? Modifie les champs et régénère (l'IA donne un visuel différent à chaque essai).</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AfficheModal;
